import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AIServiceSettingsActions } from "./aiServiceSettings.actions";

interface initialStateTypes {
    data: {
        aiServiceSettings: any;
        aiModels: any[];
        apiKeyData: any;
        openRouterSettings: any;
    };
    error: string;
    loading: boolean;
}

const initialState: initialStateTypes = {
    data: {
        aiServiceSettings: null,
        aiModels: [],
        apiKeyData: null,
        openRouterSettings: null,
    },
    error: "",
    loading: false,
};

const AIServiceSettingsSlice = createSlice(
    {
        name: "AIServiceSettingsSlice",
        initialState,
        reducers: {
            resetError: (state: any, action?: PayloadAction<any>) => {
                state.error = "";
                return state;
            }
        },
        extraReducers: (builder) => {
            builder
                // Get AI Service Settings
                .addCase(
                    AIServiceSettingsActions.getAIServiceSettings.pending,
                    (state, action) => {
                        state.error = ""
                        state.loading = true
                    }
                )
                .addCase(
                    AIServiceSettingsActions.getAIServiceSettings.fulfilled,
                    (state, action) => {
                        if (action?.payload?.data?.status === 200) {
                            state.data.aiServiceSettings = action?.payload?.data?.data;
                            state.data.aiModels = action?.payload?.data?.data?.models || [];
                            state.loading = false
                        } else {
                            state.error = action?.payload?.data?.error || "Failed to load AI service settings"
                            state.loading = false
                        }
                    }
                )
                .addCase(
                    AIServiceSettingsActions.getAIServiceSettings.rejected,
                    (state, action) => {
                        state.loading = false
                        state.data.aiServiceSettings = null
                        state.error = action?.error?.message || ""
                    }
                )
                // Save AI Service Settings
                .addCase(
                    AIServiceSettingsActions.saveAIServiceSettings.pending,
                    (state, action) => {
                        state.error = ""
                        state.loading = true
                    }
                )
                .addCase(
                    AIServiceSettingsActions.saveAIServiceSettings.fulfilled,
                    (state, action) => {
                        if (action?.payload?.data?.status === 200) {
                            state.data.aiServiceSettings = action?.payload?.data?.response;
                            state.loading = false
                        } else {
                            state.error = action?.payload?.data?.error
                            state.loading = false
                        }
                    }
                )
                .addCase(
                    AIServiceSettingsActions.saveAIServiceSettings.rejected,
                    (state, action) => {
                        state.loading = false
                        state.error = action?.error?.message || ""
                    }
                )
                // Get API Key
                .addCase(
                    AIServiceSettingsActions.getApiKey.pending,
                    (state, action) => {
                        state.error = ""
                        state.loading = true
                    }
                )
                .addCase(
                    AIServiceSettingsActions.getApiKey.fulfilled,
                    (state, action) => {
                        if (action?.payload?.data?.status === 200) {
                            state.data.apiKeyData = action?.payload?.data?.data;
                            state.loading = false
                        } else {
                            state.error = action?.payload?.data?.error || "Failed to load API key"
                            state.loading = false
                        }
                    }
                )
                .addCase(
                    AIServiceSettingsActions.getApiKey.rejected,
                    (state, action) => {
                        state.loading = false
                        state.data.apiKeyData = null
                        state.error = action?.error?.message || ""
                    }
                )
                // Save API Key
                .addCase(
                    AIServiceSettingsActions.saveApiKey.pending,
                    (state, action) => {
                        state.error = ""
                        state.loading = true
                    }
                )
                .addCase(
                    AIServiceSettingsActions.saveApiKey.fulfilled,
                    (state, action) => {
                        if (action?.payload?.data?.status === 200) {
                            state.data.apiKeyData = action?.payload?.data?.data;
                            state.loading = false
                        } else {
                            state.error = action?.payload?.data?.error
                            state.loading = false
                        }
                    }
                )
                .addCase(
                    AIServiceSettingsActions.saveApiKey.rejected,
                    (state, action) => {
                        state.loading = false
                        state.error = action?.error?.message || ""
                    }
                )
                // Save OpenRouter Settings
                .addCase(
                    AIServiceSettingsActions.saveOpenRouterSettings.pending,
                    (state, action) => {
                        state.error = ""
                        state.loading = true
                    }
                )
                .addCase(
                    AIServiceSettingsActions.saveOpenRouterSettings.fulfilled,
                    (state, action) => {
                        if (action?.payload?.data?.status === 200) {
                            state.data.openRouterSettings = action?.payload?.data?.data;
                            state.loading = false
                        } else {
                            state.error = action?.payload?.data?.error
                            state.loading = false
                        }
                    }
                )
                .addCase(
                    AIServiceSettingsActions.saveOpenRouterSettings.rejected,
                    (state, action) => {
                        state.loading = false
                        state.error = action?.error?.message || ""
                    }
                )
                // Get OpenRouter Settings
                .addCase(
                    AIServiceSettingsActions.getOpenRouterSettings.pending,
                    (state, action) => {
                        state.error = ""
                        state.loading = true
                    }
                )
                .addCase(
                    AIServiceSettingsActions.getOpenRouterSettings.fulfilled,
                    (state, action) => {
                        if (action?.payload?.data?.status === 200) {
                            state.data.openRouterSettings = action?.payload?.data?.data;
                            state.loading = false
                        } else {
                            state.error = action?.payload?.data?.error || "Failed to load OpenRouter settings"
                            state.loading = false
                        }
                    }
                )
                .addCase(
                    AIServiceSettingsActions.getOpenRouterSettings.rejected,
                    (state, action) => {
                        state.loading = false
                        state.data.openRouterSettings = null
                        state.error = action?.error?.message || ""
                    }
                )
        },
    }
);

export const { resetError } = AIServiceSettingsSlice.actions;
export default AIServiceSettingsSlice.reducer;